import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { savedFilterSelector } from '../../../../../aside_panel/filterPanelBoard/store/selectors/savedFilterSelector';
import { IFilterIconHOCProps } from './types';
import { ERestCardAssigneeInfoType } from '../../../../../../../types/rest/IRestCardAssigneeInfo';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { IFilterIconFields } from '../../components/FilterIcon/types';
import { FilterIcon } from '../../components/FilterIcon/FilterIcon';
import {
    filterPanelBoardsSelector
} from '../../../../../aside_panel/filterPanelBoard/store/selectors/filterPanelBoardsSelector';
import { MY_WORK_BOARD_ID } from '../../../../../main/myWorkView/constants';
import { fixOldColors } from '../../../Logo/components/constants';
import { getCardAssignees } from '../../../../../../../store/model/cardAssignees/selectors/getCardAssignees';

const mapStateToProps = (
    state: IApplicationState,
    { filterId, icon, direction }: IFilterIconHOCProps
): IFilterIconFields => {
    let filter = savedFilterSelector(state, filterId);
    if (!filter) {
        filter = filterPanelBoardsSelector(state, MY_WORK_BOARD_ID).editedFilter;
    }
    const { name, isPublic, author, meta, assignees } = filter;
    let userIds = [];
    const isDefaultAssignedToMe = meta.myWorkCards && meta.myWorkCards[0] === ERestCardAssigneeInfoType.ASSIGNED_TO_ME;
    if (isDefaultAssignedToMe) {
        const authUser = getAuthUser(state);
        userIds.push(authUser.permissionId);
    } else if (isPublic && author) {
        userIds.push(author.permissionId);
    } else {
        userIds = assignees;
    }

    const users = [];
    const cards = getCardAssignees(state);
    for (let cardId in cards) {
        const card = cards[cardId];
        const assignees = card.assignees || [];
        for (let i = 0; i < assignees.length; i++) {
            const assignee = assignees[i];
            const permissionId = assignee.sharedUser.permissionId;
            const idx = userIds.indexOf(permissionId);
            if (idx > -1) {
                users.push(assignee);
                userIds = userIds.filter((item) => item !== permissionId);
            }
        }
        if (!userIds.length) {
            break;
        }
    }

    return {
        direction,
        name,
        logo: !isPublic && (icon ? icon : fixOldColors(meta.myWorkIcon)),
        users,
    }
};

export const FilterIconHOC = connect(
    mapStateToProps,
    null
)(FilterIcon);

FilterIconHOC.displayName = 'FilterIconHOC';
